module.exports = __webpack_public_path__ + "img/1.c1321ff6.png";